import { SnackbarInterface } from './interfaces'
import SnackbarMUI from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'

export default function Snackbar({
  message,
  open,
  onClose,
  severity
}: SnackbarInterface) {
  return (
    <SnackbarMUI
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      message={message}
    >
      <Alert
        onClose={(e) => onClose && onClose(e)}
        severity={severity}
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </SnackbarMUI>
  )
}
